<div class="button-container">
    @if (isNewTrialButtonAvailable()) {
        <a mat-raised-button class="mat-accent new-trial-button" routerLink="/new-trial">
            <mat-icon>add</mat-icon> New Trial
        </a>
    }
</div>
<section class="form-container">
    <div class="header-wrapper">
        <h1 class="form-title">New Tenant</h1>
    </div>
    <div class="content-wrapper">
        @if (!jobId) {
            <app-new-tenant-form (formSubmitted)="createTenant($event)"></app-new-tenant-form>
        }

        @if (jobId) {
            <job-liveview [jobId]="jobId" (finished)="jobComplete($event)"></job-liveview>
        }
    </div>
</section>